/** Инициалы для аватарки-заглушки лайка (как в Telegram, пока нет фото). */
export function messengerLikeInitials(first?: string | null, last?: string | null): string {
  const f = (first ?? '').trim();
  const l = (last ?? '').trim();
  if (f && l) return (f[0]! + l[0]!).toUpperCase();
  if (f.length >= 2) return f.slice(0, 2).toUpperCase();
  if (f.length === 1) return f.toUpperCase();
  if (l.length >= 2) return l.slice(0, 2).toUpperCase();
  if (l.length === 1) return l.toUpperCase();
  return '?';
}
